<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.cost') }}
			</div>
			<v-row>
				<v-col cols="12" v-if="costId !== 0">
					<Dropdown
						:disabled="true"
						v-model="cost.teacher_id"
						:ajax="true"
						:clearable="true"
						:data="'teachers/' + $route.params.id"
						:errorBorder="!costValidation.teacher_id"
						:label="$t('fields.teacher')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!canEdit"
						v-model="cost.description"
						:errorBorder="!costValidation.description"
						:label="'* ' + $t('fields.description')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<DatePicker
						:readonly="!canEdit"
						v-model="cost.date"
						:errorBorder="!costValidation.date"
						:date-label="'* ' + $t('fields.date')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<NumberField
						:readonly="!canEdit"
						v-model="cost.unit_price"
						:precision="2"
						:errorBorder="!costValidation.unit_price"
						:label="'* ' + $t('fields.unitPrice')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<NumberField
						:readonly="!canEdit"
						v-model="cost.quantity"
						:precision="2"
						:errorBorder="!costValidation.quantity"
						:label="'* ' + $t('fields.quantity')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<InputField :disabled="true" :value="sum" :label="$t('fields.sum')"></InputField>
				</v-col>
				<v-col cols="12">
					<Upload
						:readonly="!canEdit"
						:label="$t('fields.proof')"
						v-model="cost.cost_file"
						:errorBorder="!costValidation.cost_file"
					></Upload>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn v-if="canEdit" class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import InputField from '../../trinkets/InputField';
import Dropdown from '../../trinkets/Dropdown';
import DatePicker from '../../trinkets/DatePicker';
import NumberField from '../../trinkets/NumberField';
import Upload from '../../trinkets/Upload';
import Cost from '../../../models/Cost';

export default {
	name: 'Cost',
	components: { Upload, NumberField, DatePicker, InputField, Dropdown },
	props: {
		costId: [String, Number],
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	emits: ['close', 'reloadCosts'],
	data() {
		return {
			cost: new Cost({ id: this.costId }),
			costValidation: new Cost({}, true),
		};
	},
	computed: {
		sum() {
			return (this.cost.unit_price * this.cost.quantity).toFixed(2);
		},
	},
	watch: {},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getCost() {
			var vm = this;
			this.$APICall(
				'get',
				'costs/' + this.costId,
				{},
				(data, success) => {
					if (success) {
						vm.cost = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.cost.description == null || this.cost.description == '') {
				success = false;
				this.costValidation.description = false;
			} else {
				if (this.cost.description.length > 100) {
					this.costValidation.description = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.description'))
							.replace('%length%', '100') + '<br />';
				} else {
					this.costValidation.description = true;
				}
			}

			if (this.cost.unit_price == null) {
				success = false;
				this.costValidation.unit_price = false;
			} else {
				if (this.cost.unit_price < 0.01 || this.cost.unit_price > 1000000) {
					this.costValidation.unit_price = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.unitPrice'))
							.replace('%min%', '0')
							.replace('%max%', '1000000') + '<br />';
				} else {
					this.costValidation.unit_price = true;
				}
			}

			if (!this.cost.date) {
				success = false;
				this.costValidation.date = false;
			} else {
				this.costValidation.date = true;
			}

			if (this.cost.quantity < 1 || this.cost.quantity == null) {
				success = false;
				this.costValidation.quantity = false;
			} else {
				this.costValidation.quantity = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.cost.id != 0) {
					action = 'put';
					addition = '/' + vm.cost.id;
				}
				this.cost.planned_course_id = this.plannedCourseId;
				this.$APICall(action, 'costs' + addition, this.cost, (data, success) => {
					if (success) {
						if (vm.cost.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$modalBus.$emit('reloadCosts');
						vm.$modalBus.$emit('reloadPlannedCourse');
					} else {
						if (Object.hasOwn(data, 'custom')) {
							vm.$alert(data.message);
							this.$emit('close');
							this.$router.go(-1);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
					this.$emit('close');
				});
			}
		},
	},
	mounted() {
		if (this.costId !== 0) {
			this.getCost();
		}
	},
};
</script>
